import '../../../styles/theme.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import LoginPage from '../components/customers/LoginPage';
import { VerifyLayoutProvider } from '../components/customers/hooks/useVerifyLayout/useVerifyLayout';
import { TrackingProvider } from '@jbhi-fi/components/src/Tracking';
import { getGtmData } from '../components/customers/hooks/useVerifyLayout/helpers';
import { getCustomerTrackingData } from '../../utils/event-tracking/event-data';
import { sassOptOut } from '../../utils/sassOptOut';
import { BaseContentProvider } from '../components/stack/components/BaseContentProvider/BaseContentProvider';

sassOptOut('forms');
const container = document.getElementById('AccountLoginContainer');
if (container) {
  const root = createRoot(container);
  root.render(
    <BaseContentProvider>
      <HashRouter>
        <VerifyLayoutProvider>
          <TrackingProvider
            {...getGtmData()}
            group="Logging you in..."
            pageType="Account Pages"
            trackPageLoad={false}
            getCustomerTrackingData={getCustomerTrackingData}
          >
            <LoginPage />
          </TrackingProvider>
        </VerifyLayoutProvider>
      </HashRouter>
    </BaseContentProvider>
  );
}
